import axios from 'axios';
import { ISeedCategory, ITechSheet } from 'src/infrastructure/interfaces';

export default class TechSheetService {

  static toggleTechSheetPublish(techSheet: ITechSheet) {
    return new Promise((resolve, reject) => {
    axios
        .put(`/seedtechSheet/${techSheet.id}`, techSheet)
        .then((res) => {
            resolve(res.data);
        })
        .catch(error => reject(error));
    });
  }
  
  static createTechSheet(sheetName: string, seedCategory: ISeedCategory, formData: FormData) {
    formData.set("name", sheetName);
    formData.set("categoryId", String(seedCategory.id));
    return new Promise((resolve, reject) => {
      axios
        .post('/seedtechSheet',
            formData,
            { headers: {'Content-Type': 'multipart/form-data' }})
        .then((res) => {
            resolve(res.data);
        })
        .catch(error => reject(error));
    });
  }

  static getTechSheetsZipFile(fileName: string) {
    return new Promise((resolve, reject) => {
      axios
          .get(`/seedtechsheetzip`, { params: { fileName }, responseType: 'blob' })
          .then((response) => {
            resolve(response.data);
          })
          .catch(error => reject(error));
    });
  }

  static deleteAllTechSheets() {
    return new Promise((resolve, reject) => {
      axios
      .delete(`/seedtechsheets`)
            .then((res) => {
                resolve();
            })
            .catch(error => reject(error));
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/TechSheetService.ts